// import external modules
import { combineReducers } from "redux";
// import internal(own) modules
import sidebarBgColor from "./sidebarBgColor";
import sidebarImage from "./sidebarImage";
import sidebarImageUrl from "./sidebarImageUrl";
import sidebarSize from "./sidebarSize";
import sidebarCollapsed from "./sidebarCollapsed";
import navbar from "./navbar";

const emailReducer = combineReducers({
    sidebarBgColor,
    sidebarImage,
    sidebarImageUrl,
    sidebarSize,
    sidebarCollapsed,
    navbar
});

export default emailReducer;